import { useState } from 'react';
import { api, formatTime, mutate } from '../api';
import { can, useIdentity } from '../context';
import { useLoad } from '../hooks';
import { ConfirmButton, Empty, ErrorPanel, Loading, PageHeader } from '../components/Common';

export function AuditPage() {
  const identity = useIdentity();
  const [action, setAction] = useState('');
  const [actor, setActor] = useState('');
  const [cursor, setCursor] = useState('');
  const [query, setQuery] = useState('');
  const [message, setMessage] = useState('');
  const state = useLoad(() => api<any>(`/audit?limit=100&${query}${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`), [query, cursor]);
  const items = state.data?.items || [];
  const apply = () => {
    setCursor('');
    setQuery(new URLSearchParams({ ...(action ? { action } : {}), ...(actor ? { actor } : {}) }).toString());
  };

  async function remove(id: string) {
    await mutate(`/audit/${encodeURIComponent(id)}`, 'DELETE', {}, crypto.randomUUID());
    setMessage('审计日志已删除');
    await state.reload();
  }

  async function purge() {
    const confirmation = window.prompt('这会清空全部审计日志，输入“清空审计日志”确认');
    if (confirmation !== '清空审计日志') return;
    const result = await mutate<any>('/audit/purge', 'POST', { confirmation }, crypto.randomUUID());
    setMessage(`已清空 ${result.deleted || 0} 条审计日志`);
    setCursor('');
    await state.reload();
  }

  return <>
    <PageHeader title="审计日志" description="记录后台所有授权、设备、激活码和权限变更" actions={<><button className="secondary" onClick={state.reload}>刷新</button>{can(identity, '*') && <button className="danger" onClick={purge}>清空全部日志</button>}</>} />
    <div className="panel filters"><input value={action} onChange={(event) => setAction(event.target.value)} onKeyDown={(event) => event.key === 'Enter' && apply()} placeholder="操作，如 license.disable" /><input value={actor} onChange={(event) => setActor(event.target.value)} onKeyDown={(event) => event.key === 'Enter' && apply()} placeholder="管理员邮箱" /><button onClick={apply}>筛选</button></div>
    {message && <div className="notice success">{message}</div>}
    {state.loading ? <Loading /> : state.error ? <ErrorPanel message={state.error} onRetry={state.reload} /> : <div className="panel audit-list">
      {items.map((row: any) => <details key={row.id}>
        <summary>
          <strong>{row.action}</strong>
          <span>{row.actor}</span>
          <span>{row.targetType}: {row.targetId}</span>
          <time>{formatTime(row.createdAt)}</time>
          {can(identity, '*') && <ConfirmButton danger message="确认删除这条审计日志？" onConfirm={() => remove(row.id)}>删除</ConfirmButton>}
        </summary>
        <pre>{JSON.stringify(row.detail, null, 2)}</pre>
      </details>)}
      {!items.length && <Empty />}
      {state.data?.nextCursor && <div className="pagination"><button onClick={() => setCursor(state.data.nextCursor)}>下一页</button></div>}
    </div>}
  </>;
}
